/** @jsx jsx */
import { jsx } from '@balance-web/core';
import { Box, BoxProps } from '@balance-web/box';
import { Flex, FlexProps } from '@balance-web/flex';

export type FillAndCenterProps = FlexProps & {
  fullScreen?: boolean;
  containerProps?: BoxProps;
};

export const FillAndCenter = ({
  containerProps = {},
  fullScreen = false,
  children,
  ...rest
}: FillAndCenterProps) => {
  return (
    <Flex
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        ...(!fullScreen && {
          height: '100%',
          width: '100%',
        }),
        ...(fullScreen && {
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          top: 0,
        }),
      }}
      {...rest}
    >
      <Box maxWidth="440px" {...containerProps}>
        {children}
      </Box>
    </Flex>
  );
};

export const Fullscreen: React.FC<FillAndCenterProps> = (props) => (
  <FillAndCenter fullScreen {...props} />
);
